var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgEmptyWidget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 38.2498H18.75C16.6758 38.2498 15 36.574 15 34.3943V24.6561C15 23.7537 15.3281 22.8748 15.9258 22.0897L25.2305 11.5545C26.7539 9.82012 29.4609 9.85528 30.832 11.6248L35.5313 17.1326C36.5859 18.41 38.5078 18.492 39.6797 17.3201L42.1406 14.8592C43.6758 13.324 46.2187 13.4178 47.6367 15.0701L55.3477 24.0701C55.9336 24.7498 56.25 25.617 56.25 26.5076V34.4998C56.25 36.574 54.5742 38.2498 52.5 38.2498Z",
    fill: "url(#paint0_linear_110_5912)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.75 0.75C5.8207 0.75 7.5 2.4293 7.5 4.5V43.875C7.5 44.9063 8.33906 45.75 9.375 45.75H56.25C58.3242 45.75 60 47.4258 60 49.5C60 51.5742 58.3242 53.25 56.25 53.25H9.375C4.19766 53.25 0 49.0547 0 43.875V4.5C0 2.4293 1.6793 0.75 3.75 0.75Z",
    fill: "url(#paint1_linear_110_5912)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_5912",
    x1: 35.625,
    y1: 10.2754,
    x2: 35.625,
    y2: 38.2498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_5912",
    x1: 30,
    y1: 0.75,
    x2: 30,
    y2: 53.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyWidget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/empty-widget.01babcff1c80f3d18cf5d9562e4eb7b4.svg";